/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import LoanOfficerDashboardRepository from 'repositories/loanOfficer/LoanOfficerDashboardRepository';

const initialState = {
  loading: false,
  loanOfficerDashboard: [
    { apr: null, bidRequests: null, id: null, isUser: 1, response: null, responseTime: null },
    { apr: null, bidRequests: null, id: null, isUser: 0, response: null, responseTime: null },
  ],
  meta: {},
};

const LoanOfficerDashboardSlice = createSlice({
  name: 'LoanOfficerDashboardSlice',
  initialState,
  reducers: {
    loadLoanOfficerDashboardStart(state) {
      state.loanOfficerDashboardLoading = true;
    },
    loadLoanOfficerDashboardSuccess(state, { payload }) {
      const { meta } = payload;
      state.loanOfficerDashboard = payload.loMyBundleStats;
      state.meta = meta;
      state.loanOfficerDashboardLoading = false;
    },
    loadLoanOfficerDashboardFail(state) {
      state.loanOfficerDashboardLoading = false;
    },
  },
});

export const { actions } = LoanOfficerDashboardSlice;

export default LoanOfficerDashboardSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const loadLoanOfficerDashboard = async () => {
    dispatch(actions.loadLoanOfficerDashboardStart());
    try {
      const response = await LoanOfficerDashboardRepository.index();
      dispatch(actions.loadLoanOfficerDashboardSuccess(response));
    } catch (_error) {
      dispatch(actions.loadLoanOfficerDashboardFail());
    }
  };

  return {
    loadLoanOfficerDashboard,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/loanOfficerDashboardSlice.js